"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceSection = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../../../shared/core");
var components_1 = require("../../../../../../../shared/core/components");
var copy_1 = require("../../../../../copy");
var billing_1 = require("../../../../../utils/billing");
var BlobBalanceEquation_1 = require("./BlobBalanceEquation");
exports.BalanceSection = (0, react_1.forwardRef)(function (_a, ref) {
    var openingBalance = _a.openingBalance, closingBalance = _a.closingBalance, totalCharge = _a.totalCharge, payments = _a.payments, transactions = _a.transactions, rest = __rest(_a, ["openingBalance", "closingBalance", "totalCharge", "payments", "transactions"]);
    var Stack = (0, core_1.useComponents)().Stack;
    var _b = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _b.Copy, copy = _b.copy;
    var totalPayments = (0, core_1.major2DP)((0, core_1.majorToMinor)((0, billing_1.getPaymentsTotal)(payments)));
    var openingAmount = (0, billing_1.migratedBalanceCorrection)(openingBalance, transactions).pounds;
    var openingValue = (0, core_1.absoluteMajor2DP)((0, core_1.majorToMinor)(openingAmount, 'GBP'));
    var totalCharges = (0, core_1.major2DP)((0, core_1.majorToMinor)(totalCharge.grossCharge.pounds));
    var closingValue = (0, core_1.absoluteMajor2DP)((0, core_1.majorToMinor)(closingBalance.pounds));
    return (react_1.default.createElement(Stack, __assign({ spaceBetween: [2, 4] }, rest, { ref: ref }),
        react_1.default.createElement(components_1.SectionHeader, { icon: "coin" },
            react_1.default.createElement(Copy, { copyKey: "balanceSectionHeading" })),
        react_1.default.createElement(BlobBalanceEquation_1.BlobBalanceEquation, { opening: {
                value: openingValue,
                context: parseInt(openingAmount) < 0 ? copy('inDebit') : copy('inCredit'),
            }, charges: totalCharges, payments: totalPayments, closing: {
                value: closingValue,
                context: parseInt(closingBalance.pounds) < 0
                    ? copy('inDebit')
                    : copy('inCredit'),
            } })));
});
